/**
 * @generated SignedSource<<0e91da9fbf29e6ebc0d890619b4368bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_item$data = {
  readonly hasPrivateListing: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly sortedPhotos: ReadonlyArray<{
    readonly __typename: "ItemPhoto";
    readonly alt: string | null;
    readonly largePath: string | null;
    readonly masterOrZoomPath: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselImage_sortedPhoto" | "HeroCarouselThumb_sortedPhoto" | "useItemMediaItems_sortedPhotos">;
  } | null> | null;
  readonly videoMux: {
    readonly galleryThumbnail: string | null;
    readonly height: number | null;
    readonly posterThumbnail: string | null;
    readonly thumbnail: string | null;
    readonly url: string | null;
    readonly width: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_muxVideo" | "useItemMediaItems_muxVideo">;
  } | null;
  readonly videoVimeo: {
    readonly galleryThumbnail: string | null;
    readonly height: number | null;
    readonly posterThumbnail: string | null;
    readonly thumbnail: string | null;
    readonly videoUrl: {
      readonly link: string | null;
    } | null;
    readonly vimeoId: string | null;
    readonly width: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_videoVimeo" | "VideoContainer_videoVimeo" | "useItemMediaItems_videoVimeo">;
  } | null;
  readonly viewInRoomPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_viewInRoomPhoto" | "PdpSharedImageGalleryViewInRoomImage_viewInRoomPhoto" | "ViewInRoom_viewInRoomPhoto" | "useItemMediaItems_viewInRoomPhotos">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselImage_item" | "HeroCarouselRequestMore_item" | "PdpSharedImageGalleryModal_item" | "ViewInRoom_item" | "useItemMediaItems_item">;
  readonly " $fragmentType": "PdpRespHeroCarousel_item";
};
export type PdpRespHeroCarousel_item$key = {
  readonly " $data"?: PdpRespHeroCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "includePlayButton",
  "value": false
},
v1 = {
  "kind": "Literal",
  "name": "pad",
  "value": false
},
v2 = {
  "kind": "Literal",
  "name": "size",
  "value": "w1280h720"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v5 = {
  "kind": "Literal",
  "name": "height",
  "value": 720
},
v6 = {
  "kind": "Literal",
  "name": "width",
  "value": 1280
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroCarouselImage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroCarouselRequestMore_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedImageGalleryModal_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "sortedPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_sortedPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_sortedPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselImage_sortedPhoto"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "largePath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "convertToVimeoFormat",
          "value": false
        }
      ],
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "videoVimeo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_videoVimeo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_videoVimeo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VideoContainer_videoVimeo"
        },
        {
          "alias": "galleryThumbnail",
          "args": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w1280h720\")"
        },
        {
          "alias": "posterThumbnail",
          "args": [
            (v0/*:: as any*/),
            {
              "kind": "Literal",
              "name": "pad",
              "value": true
            },
            (v2/*:: as any*/)
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(includePlayButton:false,pad:true,size:\"w1280h720\")"
        },
        {
          "alias": null,
          "args": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "kind": "Literal",
              "name": "size",
              "value": "w100h75"
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
        },
        {
          "alias": "videoUrl",
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "adaptive"
            }
          ],
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": "fileByVideoSize(size:\"adaptive\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoId",
          "storageKey": null
        },
        (v3/*:: as any*/),
        (v4/*:: as any*/)
      ],
      "storageKey": "videoVimeo(convertToVimeoFormat:false)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoV2",
      "kind": "LinkedField",
      "name": "videoMux",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_muxVideo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_muxVideo"
        },
        {
          "alias": "galleryThumbnail",
          "args": [
            {
              "kind": "Literal",
              "name": "fitMode",
              "value": "smartcrop"
            },
            (v5/*:: as any*/),
            (v6/*:: as any*/)
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(fitMode:\"smartcrop\",height:720,width:1280)"
        },
        {
          "alias": "posterThumbnail",
          "args": [
            (v5/*:: as any*/),
            (v6/*:: as any*/)
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(height:720,width:1280)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "height",
              "value": 75
            },
            {
              "kind": "Literal",
              "name": "width",
              "value": 100
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(height:75,width:100)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        (v3/*:: as any*/),
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_viewInRoomPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_viewInRoomPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ViewInRoom_viewInRoomPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedImageGalleryViewInRoomImage_viewInRoomPhoto"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "35d1dd137f08cae3c237bddfb1fb0f61";

export default node;
